import React, { Fragment, useContext } from "react";
import moment from "moment";
import {useQueryClient} from "react-query";
import { useAirports } from "../../../services/airports";
import { MovementTimes } from "../../../modules/Trips/components/TripListDialogs/MovementsTooltip";
import RouteMap from "../RouteMap";
import { Icon, IconButton } from "@material-ui/core";
import SystemContext from "../../../SystemContext";
import { useTripLegs } from "../../../services/trips";
import { useNotes } from "../../../services/notes";
import LightTooltip from "../../LightTooltip";
import __ from "lodash";
import { useComboValues } from "../../../services/settings";
import { useAircraftMovements } from "../../../services/aircraft";
import { ActionButton } from "./controls";

const AirportData = (props) => {
  const queryClient = useQueryClient();

  const airport = useAirports({queryClient, extraKeys:[props.airportCode], useCache: true});

  return (<div style={props.style}>{airport.data?airport.data[0][props.field]:props.airportCode}</div>)
}

const MapScreen = (props) => {
  const doubleWidth = props.doubleWidth || false;
  const width = doubleWidth ? 640 : 320;
  const height = doubleWidth ? 400 : 200;
  const {tripData, classes} = props;

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const noteType = "TRIP_LEG:FLIGHT_EVENT";

  const queryClient = useQueryClient();
  const extraKeys = [tripData.tripUuid, tripData.uuid];
  const tripLeg = useTripLegs({queryClient, extraKeys});

  const showBigMap = (tripData) => {
    const {airlineCode, flightNo} = tripData;
    SystemData.openAlert(
      `Route for ${airlineCode}${flightNo}`,
      (
        <div style={{width: (width * 2 + 40), height: (height * 2 + 40)}}>
          <RouteMap
            width={width * 2}
            height={height * 2}
            record={{
              uuid: tripData.uuid,
              callSign: null, //tripData.aircraftReg,
              origin: tripData.originAirportCode,
              destination: tripData.destinationAirportCode,
              tripRoute:`${tripData.originAirportCode}-${tripData.destinationAirportCode}`,
              onwardRoutes:"",
              progress: Math.max(Math.min(moment.utc().diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min')/moment.utc(tripData.scheduledArrivalTimeUtc).diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min') * 100, 100),0)
            }}
          />
        </div>
      ),
      {zIndex: 5000, maxWidth: (width * 2 + 80), fullWidth: false}
    );
  }

  const LastestDelay = (props) => {
    const {tripLeg, scheduledData} = props;
    const noteKey = [tripLeg?.delayNoteUuid||'DUMMMY'];
    const latestDelay = useNotes({queryClient, extraKeys:noteKey, useCache: true});
  
    const delayCombos = useComboValues({queryClient, extraKeys: ['DELAY CODES', '']});
    let delayData = {};
    if (delayCombos && Array.isArray(delayCombos.data) && latestDelay && Array.isArray(latestDelay.data) && latestDelay.data.length > 0) {
      delayData = __.find(delayCombos.data, {code: latestDelay?.data[0]?.delayCode})
    }
    const movements = useAircraftMovements({ queryClient, extraKeys: [(tripLeg?.aircraftMovementUuid||null)===null?"dummy":tripLeg?.aircraftMovementUuid], useCache: (tripLeg?.aircraftMovementUuid||null)===null });
  
    let actualStdOffsetMinutes = null;
    let actualEtdOffsetMinutes = null;
    if (movements && Array.isArray(movements.data) && movements.data.length > 0 && movements.data[0].offBlocksTimeUTC) {
      if (latestDelay && Array.isArray(latestDelay.data) && latestDelay.data.length > 0) {
        actualEtdOffsetMinutes = moment.utc(movements.data[0].offBlocksTimeUTC).diff(moment.utc(latestDelay.data[0].delayedUntil),'minutes');
      }
      actualStdOffsetMinutes = moment.utc(movements.data[0].offBlocksTimeUTC).diff(moment.utc(scheduledData.std),'minutes');
    }
    return (
      <div style={{width: "100%", textAlign: "center", marginTop: 10}}>
      {latestDelay.data && Array.isArray(latestDelay.data) && latestDelay.data.length > 0?
      <>
        <div className={classes.delayInfo}>
          <div style={{padding: 5, fontSize: 14}}>Latest Delay Details</div>
          <div style={{width: "100%", padding: "3px 5px", textAlign: "left"}}>
            <div style={{display: "inline-block", textAlign: "left", width: "35px", paddingRight: 5}}>Code:</div>
            <div style={{display: "inline-block", textAlign: "left", width: "40px"}}><LightTooltip title={delayData?.value||''}><span>{latestDelay.data[0].delayCode}</span></LightTooltip></div>
            <div style={{display: "inline-block", textAlign: "left", width: "55px", paddingRight: 5}}>Duration:</div>
            <div style={{display: "inline-block", textAlign: "left", width: "40px"}}>{latestDelay.data[0].delayMinutes}</div>
            <div style={{display: "inline-block", textAlign: "left", width: "35px", paddingRight: 5}}>Until:</div>
            <div style={{display: "inline-block", textAlign: "left", width: "100px"}}>{moment.utc(latestDelay.data[0].delayedUntil).format('D MMM HH:mm')}</div>
          </div>
          <div style={{width: "100%", padding: "3px 5px", textAlign: "left"}}>{latestDelay.data[0].noteText}</div>      
        </div>
      </>
      :null}
      {actualEtdOffsetMinutes > 0?
        <>
          <ActionButton 
            variant="outlined" 
            startIcon={<Icon>more_time</Icon>}
            onClick={()=>{
              SystemData.confirm(
                "Adjust Current Delay",
                "Are you sure you wish to change the duration on the current delay to match the blocks off time?",
                [
                  {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                  {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                ],
                async (response) => {
                  if (response) {
                    eventBus.trigger("RouteView.TimeWindow.TripAction.adjustDelay",{tripLegUuid: tripData.uuid, tripUuid: tripData.tripUuid});
                  }
                }
              );            
            }}
          >
            Adjust Delay
          </ActionButton> 
          <div style={{display: "inline-block", width: 5}}/>     
        </>
      :null}
      {actualStdOffsetMinutes > 0 && (actualEtdOffsetMinutes === null || actualEtdOffsetMinutes > 0)?
        <ActionButton 
          variant="outlined" 
          startIcon={<Icon>add</Icon>}
          onClick={()=>{
            eventBus.trigger("RouteView.TimeWindow.TripAction.addEvent",{tripLegUuid: tripData.uuid, noteType, tripData, delayed: true, delayedUntil: movements.data[0].offBlocksTimeUTC, etdMinutes: actualEtdOffsetMinutes>0?actualEtdOffsetMinutes:null, stdMinutes: actualStdOffsetMinutes,  title: `Flight Delay for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.std).format("D MMM")}`});
          }}
        >
          Add Event
        </ActionButton>
      :null}
    </div>
    )
  }

  const scheduledData = tripLeg?.data ? {
    aircraftMovementUuid: tripLeg.data.aircraftMovementUuid,
    std: tripLeg.data.scheduledDepartureTimeUTC,
    etd: tripLeg.data.estimatedDepartureTimeUTC,
    sta: tripLeg.data.scheduledArrivalTimeUTC,
    eta: tripLeg.data.estimatedArrivalTimeUTC,
  } : {}
return (
    <Fragment>
      <div style={{ padding: 10, paddingTop: 0, textAlign: "center"}}>
        <AirportData
          style={{fontSize: 12, padding: 4, paddingBottom: 2, width: "100%"}}
          airportCode={tripData.originAirportCode}
          field='airportName'
        />
        <div style={{fontSize: 12, transform: "rotate(180deg)"}}><Icon style={{fontSize: 10}}>flight</Icon></div>
        <AirportData
          style={{fontSize: 12, padding: 4, paddingTop: 2, width: "100%"}}
          airportCode={tripData.destinationAirportCode}
          field='airportName'
        />
      </div>
      {(tripData.type==="TRIP" && tripLeg?.data) ? <MovementTimes classes={classes} data={scheduledData} showScheduled={true}/>:null}
      <div style={{width: "100%", textAlign: "center", marginTop: 10}}>
        <div style={{display: "inline-block", position: "relative", maxWidth: width, width: width, backgroundColor: "rgba(130,130,130,0.8)"}}>
          <RouteMap
            width={width}
            height={height}
            record={{
              uuid: tripData.uuid,
              callSign: null, //tripData.aircraftReg,
              origin: tripData.originAirportCode,
              destination: tripData.destinationAirportCode,
              tripRoute:`${tripData.originAirportCode}-${tripData.destinationAirportCode}`,
              onwardRoutes:"",
              progress: Math.max(Math.min(moment.utc().diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min')/moment.utc(tripData.scheduledArrivalTimeUtc).diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min') * 100, 100),0)
            }}
          />
          <div onClick={()=> showBigMap(tripData)} style={{cursor: "pointer", position: "absolute", top: 1, right: 1, fontSize: "12px", color: "rgba(0,0,0,1)"}}><Icon fontSize={"inherit"}>aspect_ratio</Icon></div>
        </div>
      </div>
      {props.canViewDetails && tripLeg.data?
        <LastestDelay tripLeg={tripLeg.data} scheduledData={scheduledData}/>
      :null}
    </Fragment>
  );
}

export default MapScreen;
